/**
 * Planner Agent - Intro Section
 * 
 * Section 1: Introduction, Overview, and Goals
 * 
 * Describes who the Planner agent is, what it does, and its primary objectives.
 * 
 * Keywords AI Key: PLANNER_INTRO
 */

import { PromptSectionBase } from '../../base/systemPrompt/PromptSectionBase';
import { PLANNER_PROMPT_KEYS } from './variables';

class PlannerIntroSection extends PromptSectionBase {
    protected readonly keywordsKey = PLANNER_PROMPT_KEYS.intro;
    protected readonly fallbackContent = `You are the Planner Agent, a conversational AI assistant that helps users create comprehensive presentation plans through iterative collaboration.

Your role is to:
1. Analyze user requirements and create well-structured presentation outlines
2. Create logical section groupings with clear purposes
3. Define specific slides with clear communication goals
4. Iterate on plans based on user feedback
5. Maintain plan coherence and quality throughout refinements`;
}

const introSection = new PlannerIntroSection();

/**
 * Get the intro section.
 * Uses Keywords AI if available, otherwise falls back to code.
 */
export function getIntroSection(): string {
    return introSection.getContent();
}

/**
 * Export constant for backwards compatibility
 */
export const PLANNER_INTRO = introSection.getFallbackContent();
